var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCrossForViewcard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 29,
    height: 29,
    rx: 14.5,
    fill: "url(#paint0_linear_2611_4111)",
    stroke: "url(#paint1_linear_2611_4111)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2611_4111)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.5 10.5L10.5 19.5",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5 19.5L10.5 10.5",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2611_4111",
    x1: 15,
    y1: 0,
    x2: 15,
    y2: 30,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F26262"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.288298,
    stopColor: "#FC4444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D52E2E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2611_4111",
    x1: 15,
    y1: 0,
    x2: 15,
    y2: 31.0227,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8787"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D81E1E"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2611_4111"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(7 7)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossForViewcard);
export default __webpack_public_path__ + "static/media/cross_for_viewcard.b737bfabd246a34d4d30732aeb71fa2f.svg";
export { ForwardRef as ReactComponent };